import axios from "axios";
import { useState, useEffect, useRef } from "react";
import { Navigate, useSearchParams, Outlet, useNavigate } from "react-router-dom";
import { language } from "../../translation/Translate";
import { useCookies } from "react-cookie";
export const baseUrl = "https://bahg-back.icrcompany.net/api/v1/";
export const fileUrl = "https://bahg-back.icrcompany.net/storage/";

// !======================================================================================
export const usePOST = (initialState) => {
  const [formData, setFormData] = useState(initialState);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [viewFile, setViewFile] = useState("");
  const [viewImages, setViewImages] = useState({});
  const [images, setImages] = useState({});
  const [checkArray, setCheckArray] = useState({});
  const [dataPlayer, setDataPlayer] = useState();
  const [successfulPost, setSuccessfulPost] = useState(false);
  const [cookies, setCookie, removeCookie] = useCookies(["token", {
    doNotParse: true,
  }]);
  const navigate = useNavigate();
  const token = cookies.token;

  //=====================================================> function change   data all
  const handleChangeInput = (event) => {
    const { name, value, type, files, checked } = event.target;
    const newValue =
      type === "file" ? files[0] : type === "checkbox" ? checked : value;
    type === "file" && setViewFile(URL.createObjectURL(newValue));
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: newValue === true ? 1 : newValue === false ? 0 : newValue,
    }));
  };
  //=====================================================>  function change  array images
  const handleChangeArrayImages = (event) => {
    const { files, name } = event.target;
    setImages({ ...images, [name]: [files[0]] });
    if (images[name]) {
      setImages({
        ...images,
        [name]: [...images[name], files[0]],
      });
    }
    setViewImages({ ...viewImages, [name]: [URL.createObjectURL(files[0])] });
    if (images[name]) {
      setViewImages({
        ...viewImages,
        [name]: [...viewImages[name], URL.createObjectURL(files[0])],
      });
    }
  };

  //=====================================================> function change   array checkbox
  const handleCheckedArray = (e) => {
    const { value, checked, name } = e.target;
    if (checked) {
      setCheckArray({ ...checkArray, [name]: [value] });
      if (checkArray[name]) {
        setCheckArray({
          ...checkArray,
          [name]: [...checkArray[name], value],
        });
      }
    } else {
      if (checkArray[name]) {
        setCheckArray({
          ...checkArray,
          [name]: checkArray[name].filter((p) => p !== value),
        });
      }
    }
  };

  //=====================================================> post data
  const handleSubmit = async (url, route, noRoute, reload, data) => {
    setLoading(true);
    setErrors([]);
    const formDataToSend = new FormData();
    if (data)
      for (const [key, value] of Object.entries(data)) {
        formDataToSend.append(key, value);
      }
    else if (formData)
      for (const [key, value] of Object.entries(formData)) {
        formDataToSend.append(key, value);
      }
    if (checkArray)
      for (const [key, value] of Object.entries(checkArray)) {
        for (let i = 0; i < value.length; i++) {
          formDataToSend.append(key, value[i]);
        }
      }
    if (images)
      for (const [key, value] of Object.entries(images)) {
        for (let i = 0; i < value.length; i++) {
          formDataToSend.append(key, value[i]);
        }
      }

    axios
      .post(`${baseUrl}${url}`, formDataToSend, {
        headers: {
          Accept: "application/json",
          'Authorization': `Bearer ${token}`
        }
      })
      .then((res) => {
        setSuccessfulPost(true);
        setLoading(false);
        setErrors({});
        setDataPlayer(res);
        route
          ? console.log("s")
          : noRoute
            ? console.log("s")
            : reload
              ? window.location.reload()
              : window.history.go(-1);
      })
      .catch((e) => {
        setSuccessfulPost(false)
        if (e.response.status === 401 || e.response.status === 403) {
          navigate("/login")
        }
        setErrors(e.response.data?.errors);
        setLoading(false);
        setDataPlayer(e);
      });
  };
  return {
    successfulPost,
    formData,
    setFormData,
    viewFile, //  لعرض الصورة او فيديو .....
    setViewFile, // ((local)) لحذف الصورة
    viewImages, // لعرض الصور
    setViewImages, // ((local)) لحذف الصور
    images, //api  لأرسال الصور الى
    setImages, //api  لحذف الصور الى
    errors,
    setErrors,
    loading,
    setLoading,
    handleChangeInput,
    handleCheckedArray,
    handleChangeArrayImages,
    handleSubmit,
    checkArray,
    setCheckArray,
    dataPlayer,
    setSuccessfulPost
  };
};

export const useDelete = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState();
  const [listError, setListError] = useState([]);
  const [successfulDelete, setSuccessfulDelete] = useState();
  const [cookies] = useCookies(["token", {
    doNotParse: true,
  }]);

  const token = cookies.token;

  const deleteItem = async (url) => {
    setIsLoading(true);
    axios
      .delete(`${baseUrl}${url}`, {
        headers: {
          Authorization: "Bearer " + token,
          locale: language,
        },
      })
      .then((req) => {
        setIsLoading(false);
        setSuccessfulDelete(true)
        setIsError(false);
      })
      .catch((e) => {
        setSuccessfulDelete(false);
        setIsLoading(false);
        setListError([...e.response?.data?.errors]);
        setIsError(true);
      });
  };

  return { isError, isLoading, listError, successfulDelete, deleteItem }
}

//!=============================================================>start fetch data
export const useFETCH = (url, isToken) => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState("");
  const [error, setError] = useState("");
  const [cookies] = useCookies(["token", {
    doNotParse: true,
  }]);
  const navigate = useNavigate();

  const token = cookies.token;

  useEffect(() => {
    if (url) {
      setIsLoading(true);
      axios
        .get(`${baseUrl}${url}`, {
          headers: isToken ? {
            'locale': language,
            Authorization: `Bearer ${token}`
          } : {
            'locale': language
          }
        })
        .then((req) => {
          if (req) {
            setData(req.data); // Assuming req.data contains the data you need  
            setIsLoading(false);
            setIsError("");
          }
        })
        .catch((e) => {
          setIsLoading(false);
          setIsError("خطأ في جلب البيانات");
          setError(e)
        });
    }
  }, [url])

  const fetch = (url) => {
    if (url) {
      setIsLoading(true);
      axios
        .get(`${baseUrl}${url}`, {
          headers: isToken ? {
            'locale': language,
            Authorization: `Bearer ${token}`
          } : {
            'locale': language
          }
        })
        .then((req) => {
          if (req) {
            setData(req.data);
            setIsLoading(false);
            setIsError("");
          }
        })
        .catch((e) => {
          setIsLoading(false);
          setIsError("خطأ في جلب البيانات");
          setError(e)
        });
    }


  }

  //?=============================================================> deleteItem

  return { data, isLoading, isError, error, fetch };
};
//=============================================================> end fetch data

//?=============================================================> close items
export const useClose = () => {
  const [open, setOpen] = useState(false);
  const mouse = useRef();
  useEffect(() => {
    const handler = (e) => {
      if (mouse.current) {
        if (!mouse.current.contains(e.target)) {
          setOpen(false);
        }
      }
    };
    document.addEventListener("mousedown", handler);
    return () => {
      document.addEventListener("mousedown", handler);
    };
  }, []);

  return { open, setOpen, mouse };
};
//!=============================================================> pagination or filter or search
export const useFilter = (params) => {
  const [filter, setFilter] = useSearchParams();
  const handlePageClick = (event) => {
    setFilter(
      params || {
        page: event.selected + 1,
        sort_value: filter.get("sort_value") ? filter.get("sort_value") : "",
        sort_by: filter.get("sort_by") ? filter.get("sort_by") : "",
        state: filter.get("state") ? filter.get("state") : "",
      }
    );
  };
  return { filter, handlePageClick, setFilter };
};
//!=============================================================> عدم دخول من غير تسجيل دخول
export const RequireAuth = () => {
  const [cookies, setCookie, removeCookie] = useCookies(["token", {
    doNotParse: true,
  }]);

  const token = cookies.token;
  if (!token) {
    return <Navigate to="/login" />;
  }
  return <Outlet />;
};
//! =============================================================>عدم فتح صفحة تسجيل دخول اذا مسجل مسيقا
export const RequireLogin = () => {
  const [cookies, setCookie, removeCookie] = useCookies(["token", {
    doNotParse: true,
  }]);

  const token = cookies.token;
  if (!token) {
    return <Navigate to="/" />;
  }
  return <Outlet />;
};

// ==========================================================> شرط الصفحات المسموح الدخول اليها
export const RequireAdmin = ({ name }) => {
  if (name === localStorage.getItem("role_name")) {
    return <Navigate to="/403" />;
  }
  return <Outlet />;
};

//!=============================================================> تكبير الصورة
export const clickZoomInImage = (event) => {
  event.target.requestFullscreen();
};
